import { mapGetters } from "vuex";
import riskFunctions from "@/data/functions/mixins/riskFunctions.js";
import statsFunctions from "@/data/functions/mixins/statsFunctions.js";

export default {
  mixins: [riskFunctions, statsFunctions],
  data() {
    return {
      valid: true
    };
  },
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getDetail",
      "getUserStats",
      "getCompany",
      "getFacility",
      "getAsset",
      "getRelpsRemote",
      "getStatsRemote",
      "getUser"
    ])
  },
  methods: {
    defineStore(tag) {
      let store = null;
      if (tag === "G1" || tag === "K6" || tag === "B6.W1") {
        store = "changeSearchResults";
      } else if (tag === "D1") {
        store = "changeDocumentRevsList";
      } else if (tag === "D2") {
        store = "changeTrackedChangesList";
      } else if (tag === "D3") {
        store = "changeSearchResults";
      } else if (tag === "A1.A1") {
        store = "changeSearchResults";
      } else if (tag === "D4") {
        store = "changeCommsList";
      } else {
        store = null;
      }
      return store;
    },
    saveToStore(data) {
      // this.resetStore();
      // HELP
      // console.log("");
      // console.log(">>> SAVE DATA TO STORE <<<");
      // console.log(data);
      let tag = data.basic.tag;
      if (tag === "A1") {
        this.$store.dispatch("changeAsset", data);
        if (this.getAsset !== null) {
          this.startDetailStore(data);
          this.$store.dispatch("changeAssetDID", data.basic.did);
        }
      } else if (tag === "C1") {
        // console.log("SAVE STORE - COMPANY");
        this.$store.dispatch("changeCompany", data);
        this.startDetailStore(data);
      } else if (tag === "F1" || tag === "F1.Dash") {
        this.$store.dispatch("changeFacility", data);
        this.startDetailStore(data);
      } else if (tag === "U1") {
        this.startDetailStore(data);
        this.$store.dispatch("changeUser", data);
        this.$store.dispatch("changeUserDID", data.basic.did);
        this.$store.dispatch("changeCompanyDID", data.pref.select.cdid);
        // eslint-disable-next-line
        this.$store.dispatch("changeFacilityDID", data.pref.select.fdid);
      } else if (tag === "Z1") {
        this.$store.dispatch("changeDataPrivacy", data);
      } else if (tag === "Z2") {
        this.$store.dispatch("changeTermsAndConditions", data);
      } else if (tag === "Z7") {
        this.$store.dispatch("changeCommsGlobal", data);
      } else if (tag === "Z10") {
        this.$store.dispatch("changeLicence", data);
      } else {
        // ALL other documents
        // console.log(">>> ALL OTHER DOCS");
        // this.resetStoreDetail();
        this.startDetailStore(data);
      }
    },
    startDetailStore(data) {
      // GENERATE STORE
      this.startNULLStore(data);
      this.startBasicStore(data);
      this.startStatsStore(data);
      this.startAdditionalStore(data);
      this.startRelpsRemoteStore();
      this.startDIDStore(data);
      this.startLinkStore(data);
      this.startUserPrefStore(data);
    },
    startBasicStore(data) {
      // console.log("START STORE BASIC");
      let temp = data;
      if (temp.basic.tag === "U1") {
        // console.log("START STORE BASIC USER");
        temp.basic.act = this.getUserStats.act;
        temp.basic.rlic = this.getUserStats.rlic;
        // UPDATE USER
        this.$store.dispatch("changeUser", temp);
      }
      // STORE BASIC
      this.$store.dispatch("changeDetail", temp);
      this.$store.dispatch("changeDetailBasic", temp.basic);
      this.$store.dispatch("changeDetailChar", temp.char);
      this.$store.dispatch("changeDetailRev", temp.rev);
      this.$store.dispatch("changeDocumentRevMod", temp.rev.nmod);
      this.$store.dispatch("changeDataSavePendingIndication", false);
    },
    startStatsStore(data) {
      // console.log("START STORE STATS");
      // DEFINE
      let tag = data.basic.tag;
      let stats = null;
      // CHECK for REMOTE OR LOCAL STATS
      if (tag === "U1") {
        stats = this.getUserStats;
      } else if (
        tag !== "U1" &&
        this.enableStatsRemote(tag) &&
        this.getStatsRemote !== null &&
        this.getStatsRemote !== undefined
      ) {
        stats = this.getStatsRemote;
      } else {
        stats = data.stats;
      }
      // UPDATE STORE
      // stats = undefined;
      this.$store.dispatch("changeDetailStats", stats);
      // console.log(stats.nd4);
    },
    startAdditionalStore(data) {
      // PREF
      if (data.pref !== undefined) {
        this.$store.dispatch("changeDetailPref", data.pref);
      }
      // TRANSITIONS
      if (data.trans !== undefined) {
        this.$store.dispatch("changeTransitions", data.trans);
      }
      // LINK
      let tag = data.basic.tag;
      if (data.link !== undefined) {
        if (tag !== "U1") {
          this.$store.dispatch("changeDetailLink", data.link);
        } else {
          this.$store.dispatch("changeDetailLink", null);
        }
      }
    },
    startSpecialStore(data) {
      let tag = data.basic.tag;
      let relps = this.getRelpsRemote;
      if (tag === "C1") {
        this.$store.dispatch("changeCompanyRelps", relps);
      }
    },
    startDIDStore(data) {
      // console.log("START STORE DID");
      let tag = data.basic.tag;
      if (tag === "A1") {
        this.$store.dispatch("changeAssetDID", data.basic.did);
      }
      if (tag === "B3") {
        this.$store.dispatch("changeCompanyDID", data.link.cdid);
        this.$store.dispatch("changeFacilityDID", data.link.fdid);
      }
      if (tag === "B4") {
        this.$store.dispatch("changeBudgetDID", data.basic.did);
      }
      if (tag === "B6") {
        this.$store.dispatch("changePlanDID", data.basic.did);
      }
      if (tag === "L1") {
        this.$store.dispatch("changeMaterialDID", data.basic.did);
      }
      if (tag === "M2") {
        this.$store.dispatch("changeMaintStrategyDID", data.basic.did);
      }
      if (tag === "M5") {
        this.$store.dispatch("changeMaintPlanDID", data.basic.did);
      }
    },
    startLinkStore(data) {
      // console.log("START STORE LINK");
      let tag = data.basic.tag;
      if (tag !== "U1" && tag !== "C1") {
        if (tag !== "B6" && data.link.pdid !== undefined) {
          this.$store.dispatch("changePlanDID", data.link.pdid);
        }
      }
    },
    startUserPrefStore(data) {
      if (data.basic.tag === "U1" && this.getUserStats !== null) {
        // CHECK COMPANY LOCK
        let pref = this.getUser.pref;
        let user = this.getUser;
        let lockc = this.getUserStats.alockc;
        let lockcdid = this.getUserStats.alockcdid;
        let lockf = this.getUserStats.alockf;
        let lockfdid = this.getUserStats.alockfdid;
        // Company Lock
        if (lockc === true && lockcdid === pref.select.cdid) {
          // PREF
          pref.select.cauth = null;
          pref.select.cdid = "";
          pref.select.cid = "";
          pref.select.cidg = "";
          pref.select.cname = "";
          pref.select.cshort = "";
          pref.select.ctag = "";
          pref.select.fauth = null;
          pref.select.fdid = "";
          pref.select.fid = "";
          pref.select.fidg = "";
          pref.select.fname = "";
          pref.select.fshort = "";
          pref.select.ftag = "";
          // UPDATE STORE
          user.pref = pref;
          this.$store.dispatch("changeUser", user);
          this.$store.dispatch("changeDetail", user);
          this.$store.dispatch("changeDetailPref", pref);
        }
        // Facility lock
        if (
          lockc === false &&
          lockf === true &&
          lockfdid === pref.select.fdid
        ) {
          // PREF
          pref.select.fauth = null;
          pref.select.fdid = "";
          pref.select.fid = "";
          pref.select.fidg = "";
          pref.select.fname = "";
          pref.select.fshort = "";
          pref.select.ftag = "";
          // UPDATE STORE
          user.pref = pref;
          this.$store.dispatch("changeUser", user);
          this.$store.dispatch("changeDetail", user);
          this.$store.dispatch("changeDetailPref", pref);
        }
      }
    },
    startNULLStore(data) {
      // console.log("START STORE NULL");
      let tag = data.basic.tag;
      if (tag === "A1") {
        this.$store.dispatch("changeTransitions", null);
      }
    },
    startRelpsRemoteStore() {
      // console.log("START STORE RELPS");
      // DEFINE
      let stats = this.getDetailStats;
      let relps = this.getRelpsRemote;
      // console.log("STATS: ");
      // console.log(stats);
      // console.log("RELPS: ");
      // console.log(relps);
      this.$store.dispatch("changeDetailRelps", relps);
      if (relps !== null && relps !== undefined) {
        // ASSETS REGISTER
        if (relps.a1 !== undefined && relps.a1 !== null) {
          // console.log("ASSET REGISTER LOADED");
          this.$store.dispatch("changeAssetRegister", relps.a1);
          this.$store.dispatch("changeAssetRegisterCounter", stats.na1);
        }
        // DEFINE REGISTERS (IMPORTED RELATIONSHIPS)
        if (relps.b1 !== undefined && relps.b1 !== null) {
          this.$store.dispatch("changeFacilityRegister", relps.b1);
          this.$store.dispatch("changeFacilityRegisterCounter", stats.nb1);
        }
        if (relps.b3 !== undefined && relps.b3 !== null) {
          this.$store.dispatch("changeActionRegister", relps.b3);
          this.$store.dispatch("changeActionRegisterCounter", stats.nb3);
        }
        if (relps.b7 !== undefined && relps.b7 !== null) {
          this.$store.dispatch("changeLimitsList", relps.b7);
          this.$store.dispatch("changeLimitsListCounter", stats.nb7);
        }
        if (relps.d4 !== undefined && relps.d4 !== null) {
          this.$store.dispatch("changeAttachmentList", relps.d4);
          this.$store.dispatch("changeAttachmentListCounter", stats.nd4);
        }
        if (relps.g4 !== undefined && relps.g4 !== null) {
          this.$store.dispatch("changeRolesList", relps.g4);
          this.$store.dispatch("changeRolesListCounter", stats.ng4);
        }
        if (relps.h5 !== undefined && relps.h5 !== null) {
          this.$store.dispatch("changeResourcesList", relps.h5);
          this.$store.dispatch("changeResourcesListCounter", stats.nh5);
        }
        if (relps.e3 !== undefined && relps.e3 !== null) {
          this.$store.dispatch("changeAnalysisList", relps.e3);
          this.$store.dispatch("changeAnalysisListCounter", stats.ne3);
        }
        if (relps.e5 !== undefined && relps.e5 !== null) {
          this.$store.dispatch("changeResultsList", relps.e5);
          this.$store.dispatch("changeResultsListCounter", stats.ne5);
        }
        if (relps.f1 !== undefined && relps.f1 !== null) {
          this.$store.dispatch("changeFacilityRegister", relps.f1);
          this.$store.dispatch("changeFacilityRegisterCounter", stats.nf1);
        }
        if (relps.k4 !== undefined && relps.k4 !== null) {
          // this.$store.dispatch("changeRelationshipsRegister", relps.k4);
          // this.$store.dispatch("changeRelationshipsRegisterCounter", stats.nk4);
        }
        if (relps.l1 !== undefined && relps.l1 !== null) {
          this.$store.dispatch("changeMaterialRegister", relps.l1);
          this.$store.dispatch("changeMaterialRegisterCounter", stats.nl1);
        }
        if (relps.l5 !== undefined && relps.l5 !== null) {
          this.$store.dispatch("changePartsList", relps.l5);
          this.$store.dispatch("changePartsListCounter", stats.nl5);
        }
        if (relps.l7 !== undefined && relps.l7 !== null) {
          this.$store.dispatch("changeInventoryList", relps.l7);
          this.$store.dispatch("changeInventoryListCounter", stats.nl7);
        }
        if (relps.o5 !== undefined && relps.o5 !== null) {
          this.$store.dispatch("changePermitsList", relps.o5);
          this.$store.dispatch("changePermitsListCounter", stats.no5);
        }
        if (relps.s1 !== undefined && relps.s1 !== null) {
          this.$store.dispatch("changeHazardRegister", relps.s1);
          this.$store.dispatch("changeHazardRegisterCounter", stats.ns1);
        }
        if (relps.s2 !== undefined && relps.s2 !== null) {
          this.$store.dispatch("changeRiskAssessmentList", relps.s2);
          // eslint-disable-next-line
          this.$store.dispatch("changeRiskAssessmentListCounter", stats.ns2);
          let risk = this.calcRiskTotal(relps.s2);
          this.$store.dispatch("changeRiskAssessmentListRiskCounter", risk);
          // eslint-disable-next-line
          this.$store.dispatch("changeRiskAssessmentListCounter", stats.ns2);
        }
        if (relps.m1 !== undefined && relps.m1 !== null) {
          this.$store.dispatch("changeMaintActivityList", relps.m1);
          this.$store.dispatch("changeMaintActivityListCounter", stats.nm1);
        }
        if (relps.w5 !== undefined && relps.w5 !== null) {
          this.$store.dispatch("changeTasksList", relps.w5);
          this.$store.dispatch("changeTasksListCounter", stats.nw5);
        }
      }
    },
    startAccessStore() {
      // console.log("START ACCESS STORE");
      this.$store.dispatch("changeDetailStats", this.getDetail.stats);
      this.$store.dispatch("changeTransitions", this.getDetail.trans);
      this.$store.dispatch("changeDetailSelect", this.getDetail.select);
      this.$store.dispatch("changeDocumentRevMod", this.getDetail.rev.nmod);
      if (this.getDetail.basic.tags === "C1") {
        this.$store.dispatch("changeCompanyDID", this.getDetail.char.did);
      } else {
        this.$store.dispatch("changeFacilityDID", this.getDetail.char.did);
      }
    },
    updateStoreDetail(tag, data) {
      // console.log("CHANGE STORE DETAIL");
      this.$store.dispatch("changeDetail", data);
      if (tag === "U1") {
        // console.log("HERE CHANGE USER");
        console.log(data);
        this.$store.dispatch("changeUser", data);
      }
      if (tag === "C1") {
        this.$store.dispatch("changeCompany", data);
      }
      if (tag === "F1") {
        this.$store.dispatch("changeFacility", data);
      }
    },
    startUserCompanyFacilityDID() {
      console.log("");
      // console.log("START DID for USER/FACILTY/COMPANY");
      let udid = this.getUser.basic.did;
      let cdid = this.getUser.pref.select.cdid;
      let fdid = this.getUser.pref.select.fdid;
      this.$store.dispatch("changeUserDID", udid);
      this.$store.dispatch("changeCompanyDID", cdid);
      this.$store.dispatch("changeFacilityDID", fdid);
    },
    resetStore() {
      // console.log("RESET STORE");
      this.$store.dispatch("changeInfoCard", null);
      // this.$store.dispatch("changeUserSec", null);
      // this.resetStoreDetail();
    },
    resetStoreDetail() {
      // console.log("");
      // console.log(">>> RESET STORE DETAIL <<<");
      this.$store.dispatch("changeDetail", null);
      this.$store.dispatch("changeDetailBasic", null);
      this.$store.dispatch("changeDetailChar", null);
      this.$store.dispatch("changeDetailPref", null);
      this.$store.dispatch("changeDetailRelps", null);
      this.$store.dispatch("changeDetailLink", null);
      this.$store.dispatch("changeDetailRev", null);
      this.$store.dispatch("changeDetailStats", null);
      this.$store.dispatch("changeDataSavePendingIndication", false);
      this.$store.dispatch("changeRolesList", null);
      this.$store.dispatch("changeRolesListCounter", null);
      this.$store.dispatch("changeAttachmentList", null);
      this.$store.dispatch("changeAttachmentListCounter", null);
      this.$store.dispatch("changeResourcesList", null);
      this.$store.dispatch("changeResourcesListCounter", null);
      this.$store.dispatch("changePartsList", null);
      this.$store.dispatch("changePartsListCounter", null);
      this.$store.dispatch("changeAnalysisList", null);
      this.$store.dispatch("changeAnalysisListCounter", null);
      this.$store.dispatch("changeMaintActivityList", null);
      this.$store.dispatch("changeMaintActivityListCounter", null);
      this.$store.dispatch("changeTasksList", null);
      this.$store.dispatch("changeTasksListCounter", null);
      this.$store.dispatch("changeResultsList", null);
      this.$store.dispatch("changeResultsListCounter", null);
      this.$store.dispatch("changeInventoryList", null);
      this.$store.dispatch("changeInventoryListCounter", null);
      this.$store.dispatch("changeHazardRegister", null);
      this.$store.dispatch("changeHazardRegisterCounter", null);
      this.$store.dispatch("changeFacilityRegister", null);
      this.$store.dispatch("changeFacilityRegisterCounter", null);
      this.$store.dispatch("changeAssetRegister", null);
      this.$store.dispatch("changeAssetRegisterCounter", null);
      this.$store.dispatch("changeAssetRegisterTree", null);
      this.$store.dispatch("changeAssetRegisterTreeCounter", null);
      this.$store.dispatch("changeDocumentLogTag", null);
      this.$store.dispatch("changeDocumentLogCompanyUnreadCounter", null);
      this.$store.dispatch("changeDocumentLogCompanyAttentionCounter", null);
      this.$store.dispatch("changeDocumentLogFacilityUnreadCounter", null);
      this.$store.dispatch("changeDocumentLogFacilityAttentionCounter", null);
      this.$store.dispatch("changeRelpsRemote", null);
      this.$store.dispatch("changeStatsRemote", null);
      this.$store.dispatch("changePageInfo", null);
      this.$store.dispatch("changeMaterialDID", null);
      // this.$store.dispatch("changePlanDID", null);
      // this.$store.dispatch("changeBudgetDID", null);
      this.$store.dispatch("changeOrgDetailBasic", null);
      // this.$store.dispatch("changeDocumentLogUserUnreadCounter", null);
      // this.$store.dispatch("changeDocumentLogUserAttentionCounter", null);
    },
    resetRegisters() {
      this.$store.dispatch("changeTransitions", null);
      this.$store.dispatch("changeSearchResults", null);
      this.$store.dispatch("changeSearchResultsCounter", null);
    },
    resetStoreCompany() {
      // console.log("RESET STORE COMPANY");
      this.$store.dispatch("changeCompany", null);
      this.$store.dispatch("changeCompanyDID", null);
    },
    resetStoreFacility() {
      // console.log("RESET STORE FACILITY");
      this.$store.dispatch("changeFacility", null);
      this.$store.dispatch("changeFacilityDID", null);
    },
    resetCompanyFacilityStore() {
      this.$store.dispatch("changeCompany", null);
      this.$store.dispatch("changeCompanyDID", null);
      this.$store.dispatch("changeFacility", null);
      this.$store.dispatch("changeFacilityDID", null);
    },
    logoutStore() {
      // user
      this.$store.dispatch("changeUser", null);
      this.$store.dispatch("changeUserDID", null);
      this.$store.dispatch("changeInfoCard", null);
      this.$store.dispatch("changeUserActions", null);
      this.$store.dispatch("changeUserAccessList", null);
      this.$store.dispatch("changeRoleAssigneeDIDCurrent", null);
      this.$store.dispatch("changeRoleAssigneeDIDPrevious", null);
      this.$store.dispatch("changeUserStats", null);
      // this.$store.dispatch("changeUserRelps", null);

      // detail
      this.$store.dispatch("changeDetail", null);
      this.$store.dispatch("changeDetailBasic", null);
      this.$store.dispatch("changeDetailChar", null);
      this.$store.dispatch("changeDetailPref", null);
      this.$store.dispatch("changeDetailRelps", null);
      this.$store.dispatch("changeDetailRev", null);
      this.$store.dispatch("changeDetailStats", null);

      // original
      this.$store.dispatch("changeOriginal", null);

      // admin
      this.$store.dispatch("changeAdmin", null);
      this.$store.dispatch("changeAdminBasic", null);

      // company
      this.$store.dispatch("changeCompany", null);
      this.$store.dispatch("changeCompanyDID", null);
      this.$store.dispatch("changeCompanyAccess", null);

      // facility
      this.$store.dispatch("changeFacility", null);
      this.$store.dispatch("changeFacilityDID", null);
      this.$store.dispatch("changeFacilityAccess", null);

      // others
      this.$store.dispatch("changeActionList", null);
      this.$store.dispatch("changeAttachmentList", null);
      this.$store.dispatch("changeAttachmentListCounter", null);
      this.$store.dispatch("changeRolesList", null);
      this.$store.dispatch("changeRolesListCounter", null);
      this.$store.dispatch("changeSearchResults", null);
      this.$store.dispatch("changeSearchResultsCounter", null);
      this.$store.dispatch("changeDataSavePendingIndication", false);

      // businss
      this.$store.dispatch("changeMaterialDID", null);
      this.$store.dispatch("changePlanDID", null);

      // licence
      this.$store.dispatch("changeDataPrivacy", null);
      this.$store.dispatch("changeTermsAndConditions", null);

      // remote
      this.$store.dispatch("changeStatsRemote", null);
    }
  }
};
